// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IBankMethodsDto,
  IBusinessEntityTypeDto,
  ICheckWritingTypeDto,
  IClaimsByServiceSearchDto,
  IClaimsTeamCreateDto,
  IClaimsTeamInfoDto,
  IClaimsTeamSaveContactDto,
  IClaimsTeamUpdateDto,
  IContactByClaimsTeamsDto,
  IContactCountDto,
  IContactDataDto,
  IContactInfoDto,
  IContactInfoLiteDto,
  IContactSaveClaimsTeamsDto,
  IContactSaveDto,
  ICustomPageContactInfoDto,
  ICustomPageOrganizationShortDto,
  IElectronicFundingDto,
  IEligibleDependentsDto,
  IEmailIllustrationDto,
  IEmployeeOverridablePropertiesInfoDto,
  IEmployerTerminationPropertiesDto,
  IErrorDto,
  IExpressContactSaveDto,
  IExpressContactStatusDto,
  IExpressSetupInfoDto,
  IGenericErrorDto,
  IHashIdOverridablePropertiesDto,
  IHierarchyNode,
  IHsaCustodianConfigDto,
  IHsaCustodianTypeDto,
  IIdSourceTypeDto,
  ILinkVerificationCodeValidationRequestDto,
  IMobileAppThemeDto,
  INotificationPropertiesInfoDto,
  IOrganizationEmailTemplateLogoDto,
  IOrganizationInfoDto,
  IOrganizationLiteDto,
  IOrganizationLogoDto,
  IOrganizationNameDto,
  IOrganizationNoteDto,
  IOrganizationPhoneInfoDto,
  IOrganizationPropertyInfoDto,
  IOrganizationReactivationRequest,
  IOrganizationResolverEnum,
  IOrganizationShortDto,
  IOrganizationViewDto,
  IOverridablePropertiesInfoDto,
  IOverridablePropertiesValidateDto,
  IPreferredDto,
  IPropagateOverridablePropertiesRequest,
  IPropagateOverridablePropertiesResponse,
  IRelationshipTypeDto,
  ISearchOrganizationDto,
  IVerificationCodeRequestCreateDto,
  IVerificationCodeValidationResponseDto,
} from '../models/index';
import {
    IBankMethodsDtoFromJSON,
    IBankMethodsDtoToJSON,
    IBusinessEntityTypeDtoFromJSON,
    IBusinessEntityTypeDtoToJSON,
    ICheckWritingTypeDtoFromJSON,
    ICheckWritingTypeDtoToJSON,
    IClaimsByServiceSearchDtoFromJSON,
    IClaimsByServiceSearchDtoToJSON,
    IClaimsTeamCreateDtoFromJSON,
    IClaimsTeamCreateDtoToJSON,
    IClaimsTeamInfoDtoFromJSON,
    IClaimsTeamInfoDtoToJSON,
    IClaimsTeamSaveContactDtoFromJSON,
    IClaimsTeamSaveContactDtoToJSON,
    IClaimsTeamUpdateDtoFromJSON,
    IClaimsTeamUpdateDtoToJSON,
    IContactByClaimsTeamsDtoFromJSON,
    IContactByClaimsTeamsDtoToJSON,
    IContactCountDtoFromJSON,
    IContactCountDtoToJSON,
    IContactDataDtoFromJSON,
    IContactDataDtoToJSON,
    IContactInfoDtoFromJSON,
    IContactInfoDtoToJSON,
    IContactInfoLiteDtoFromJSON,
    IContactInfoLiteDtoToJSON,
    IContactSaveClaimsTeamsDtoFromJSON,
    IContactSaveClaimsTeamsDtoToJSON,
    IContactSaveDtoFromJSON,
    IContactSaveDtoToJSON,
    ICustomPageContactInfoDtoFromJSON,
    ICustomPageContactInfoDtoToJSON,
    ICustomPageOrganizationShortDtoFromJSON,
    ICustomPageOrganizationShortDtoToJSON,
    IElectronicFundingDtoFromJSON,
    IElectronicFundingDtoToJSON,
    IEligibleDependentsDtoFromJSON,
    IEligibleDependentsDtoToJSON,
    IEmailIllustrationDtoFromJSON,
    IEmailIllustrationDtoToJSON,
    IEmployeeOverridablePropertiesInfoDtoFromJSON,
    IEmployeeOverridablePropertiesInfoDtoToJSON,
    IEmployerTerminationPropertiesDtoFromJSON,
    IEmployerTerminationPropertiesDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IExpressContactSaveDtoFromJSON,
    IExpressContactSaveDtoToJSON,
    IExpressContactStatusDtoFromJSON,
    IExpressContactStatusDtoToJSON,
    IExpressSetupInfoDtoFromJSON,
    IExpressSetupInfoDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IHashIdOverridablePropertiesDtoFromJSON,
    IHashIdOverridablePropertiesDtoToJSON,
    IHierarchyNodeFromJSON,
    IHierarchyNodeToJSON,
    IHsaCustodianConfigDtoFromJSON,
    IHsaCustodianConfigDtoToJSON,
    IHsaCustodianTypeDtoFromJSON,
    IHsaCustodianTypeDtoToJSON,
    IIdSourceTypeDtoFromJSON,
    IIdSourceTypeDtoToJSON,
    ILinkVerificationCodeValidationRequestDtoFromJSON,
    ILinkVerificationCodeValidationRequestDtoToJSON,
    IMobileAppThemeDtoFromJSON,
    IMobileAppThemeDtoToJSON,
    INotificationPropertiesInfoDtoFromJSON,
    INotificationPropertiesInfoDtoToJSON,
    IOrganizationEmailTemplateLogoDtoFromJSON,
    IOrganizationEmailTemplateLogoDtoToJSON,
    IOrganizationInfoDtoFromJSON,
    IOrganizationInfoDtoToJSON,
    IOrganizationLiteDtoFromJSON,
    IOrganizationLiteDtoToJSON,
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoToJSON,
    IOrganizationNameDtoFromJSON,
    IOrganizationNameDtoToJSON,
    IOrganizationNoteDtoFromJSON,
    IOrganizationNoteDtoToJSON,
    IOrganizationPhoneInfoDtoFromJSON,
    IOrganizationPhoneInfoDtoToJSON,
    IOrganizationPropertyInfoDtoFromJSON,
    IOrganizationPropertyInfoDtoToJSON,
    IOrganizationReactivationRequestFromJSON,
    IOrganizationReactivationRequestToJSON,
    IOrganizationResolverEnumFromJSON,
    IOrganizationResolverEnumToJSON,
    IOrganizationShortDtoFromJSON,
    IOrganizationShortDtoToJSON,
    IOrganizationViewDtoFromJSON,
    IOrganizationViewDtoToJSON,
    IOverridablePropertiesInfoDtoFromJSON,
    IOverridablePropertiesInfoDtoToJSON,
    IOverridablePropertiesValidateDtoFromJSON,
    IOverridablePropertiesValidateDtoToJSON,
    IPreferredDtoFromJSON,
    IPreferredDtoToJSON,
    IPropagateOverridablePropertiesRequestFromJSON,
    IPropagateOverridablePropertiesRequestToJSON,
    IPropagateOverridablePropertiesResponseFromJSON,
    IPropagateOverridablePropertiesResponseToJSON,
    IRelationshipTypeDtoFromJSON,
    IRelationshipTypeDtoToJSON,
    ISearchOrganizationDtoFromJSON,
    ISearchOrganizationDtoToJSON,
    IVerificationCodeRequestCreateDtoFromJSON,
    IVerificationCodeRequestCreateDtoToJSON,
    IVerificationCodeValidationResponseDtoFromJSON,
    IVerificationCodeValidationResponseDtoToJSON,
} from '../models/index';

export interface ActivateOrganizationRequest {
    organizationId: number;
}

export interface AssignClaimsTeamsToContactRequest {
    contactId: number;
    iContactSaveClaimsTeamsDto: IContactSaveClaimsTeamsDto;
}

export interface AssignContactsToClaimsTeamRequest {
    claimsTeamId: number;
    iClaimsTeamSaveContactDto: IClaimsTeamSaveContactDto;
}

export interface CreateClaimsTeamRequest {
    iClaimsTeamCreateDto: IClaimsTeamCreateDto;
}

export interface CreateContactRequest {
    iContactSaveDto: IContactSaveDto;
}

export interface CreateExpressContactRequest {
    iExpressContactSaveDto: IExpressContactSaveDto;
}

export interface CreateOrganizationRequest {
    iOrganizationInfoDto: IOrganizationInfoDto;
}

export interface CreateOrganizationAddressRequest {
    organizationId: number;
    addressId: number;
    iPreferredDto: IPreferredDto;
}

export interface CreateOrganizationPhoneRequest {
    organizationId: number;
    iOrganizationPhoneInfoDto: IOrganizationPhoneInfoDto;
}

export interface CreateOrganizationPropertyRequest {
    organizationId: number;
    iOrganizationPropertyInfoDto: IOrganizationPropertyInfoDto;
}

export interface CreateVerificationCodeRequest {
    iVerificationCodeRequestCreateDto: IVerificationCodeRequestCreateDto;
}

export interface DeleteClaimsTeamRequest {
    claimsTeamId: number;
}

export interface DeleteTerminationSetupConfigRequest {
    organizationId: number;
}

export interface FetchTerminationSetupConfigRequest {
    organizationId: number;
}

export interface FindClaimsTeamsByContactRequest {
    contactId: number;
}

export interface FindExpressSetupPropertiesByDistributorRequest {
    distributorId: number;
}

export interface FindOrganizationNoteRequest {
    organizationId: number;
}

export interface FindOrganizationPropertiesByHashIdRequest {
    hashId: string;
}

export interface FindOrganizationPropertyRequest {
    organizationId: number;
}

export interface FindOrganizationsByAccountManagerIdRequest {
    accountManagerId: number;
}

export interface GetAllContactsRequest {
    searchValue?: string;
    organizationId?: number;
    claimsTeamId?: number;
    permissionIds?: Set<number>;
    type?: Set<number>;
    ids?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAllContactsLiteRequest {
    searchValue?: string;
    organizationId?: number;
    claimsTeamId?: number;
    ids?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAppealEligibleContactsRequest {
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetClaimsTeamRequest {
    claimsTeamId: number;
}

export interface GetContactRequest {
    contactId: number;
}

export interface GetContactCountRequest {
    roleId: number;
}

export interface GetContactsRequest {
    ids: Set<number>;
}

export interface GetContactsByClaimTeamsRequest {
    iContactByClaimsTeamsDto: IContactByClaimsTeamsDto;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetContactsUpHierarchyRequest {
    organizationId: number;
    jobFunction?: GetContactsUpHierarchyJobFunctionEnum;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetEmployeeOverridablePropertiesRequest {
    organizationId: number;
}

export interface GetOrganizationRequest {
    organizationId: number;
    xDETAILSRESOLVERS?: Set<IOrganizationResolverEnum>;
}

export interface GetOrganizationAddressRequest {
    organizationId: number;
    addressId: number;
}

export interface GetOrganizationByExternalIdRequest {
    externalId: string;
}

export interface GetOrganizationByIdLiteRequest {
    id: number;
}

export interface GetOrganizationEmployeeViewRequest {
    organizationId: number;
}

export interface GetOrganizationHierarchyRequest {
    searchValue: string;
}

export interface GetOrganizationHierarchyByClaimsTeamRequest {
    claimsTeamId: number;
}

export interface GetOrganizationNameByIdRequest {
    id: number;
}

export interface GetOrganizationNamesByIdsRequest {
    ids: Set<number>;
}

export interface GetOrganizationPhoneRequest {
    organizationId: number;
    phoneId: number;
}

export interface GetOrganizationPhonesRequest {
    organizationId: number;
}

export interface GetOverridablePropertiesRequest {
    organizationId: number;
}

export interface OrganizationVerifyCodeFromLinkRequest {
    iLinkVerificationCodeValidationRequestDto: ILinkVerificationCodeValidationRequestDto;
}

export interface PropagateOverridablePropertiesRequest {
    organizationId: number;
    iPropagateOverridablePropertiesRequest: IPropagateOverridablePropertiesRequest;
}

export interface ReactivateRequest {
    organizationId: number;
    iOrganizationReactivationRequest: IOrganizationReactivationRequest;
}

export interface SaveOrganizationCustomEmailTemplateLogoRequest {
    organizationId: number;
    file: Blob;
}

export interface SaveOrganizationLogoRequest {
    organizationId: number;
    logoType: SaveOrganizationLogoLogoTypeEnum;
    file: Blob;
}

export interface SearchAllClaimTeamsByOrgPathAndServiceIdRequest {
    requestBody: { [key: string]: Array<IClaimsByServiceSearchDto>; };
}

export interface SearchClaimsTeamsRequest {
    claimsTeamName?: string;
    contactId?: number;
}

export interface SearchEmailIllustrationsRequest {
    orgPath: string;
}

export interface SearchOrganizationServiceIntersectionRequest {
    iClaimsTeamCreateDto: IClaimsTeamCreateDto;
}

export interface SearchOrganizationsWithSubsidiariesRequest {
    organizationName: string;
}

export interface SearchShortOrganizationsRequest {
    iSearchOrganizationDto: ISearchOrganizationDto;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface UnassignAllAccountManagerRolesRequest {
    contactId: number;
}

export interface UpdateClaimsTeamRequest {
    claimsTeamId: number;
    iClaimsTeamUpdateDto: IClaimsTeamUpdateDto;
}

export interface UpdateClockInRequest {
    contactId: number;
    clockIn: boolean;
}

export interface UpdateContactRequest {
    contactId: number;
    iContactSaveDto: IContactSaveDto;
}

export interface UpdateContactStatusRequest {
    contactId: number;
    iExpressContactStatusDto: IExpressContactStatusDto;
}

export interface UpdateOrganizationRequest {
    organizationId: number;
    iOrganizationInfoDto: IOrganizationInfoDto;
}

export interface UpdateOrganizationAddressRequest {
    organizationId: number;
    addressId: number;
    iPreferredDto: IPreferredDto;
}

export interface UpdateOrganizationNotificationPropertiesRequest {
    organizationId: number;
    iNotificationPropertiesInfoDto: INotificationPropertiesInfoDto;
}

export interface UpdateOrganizationPropertyRequest {
    organizationId: number;
    iOrganizationPropertyInfoDto: IOrganizationPropertyInfoDto;
}

export interface UpdateOrganizationStatusRequest {
    organizationId: number;
    status: UpdateOrganizationStatusStatusEnum;
    isExpressSetupActivation?: boolean;
}

export interface UpdateOverridablePropertyRequest {
    organizationId: number;
    iOverridablePropertiesInfoDto: IOverridablePropertiesInfoDto;
}

export interface ValidateOrganizationToCreateEmployeeRequest {
    organizationId: number;
}

export interface ValidateOverridablePropertiesRequest {
    organizationId: number;
    iOverridablePropertiesInfoDto: IOverridablePropertiesInfoDto;
}

export interface ValidateUserNameNotExistsRequest {
    names: Set<string>;
}

/**
 * OrganizationServiceServiceApi - interface
 * 
 * @export
 * @interface OrganizationServiceServiceApiInterface
 */
export interface OrganizationServiceServiceApiInterface {
    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    activateOrganizationRaw(requestParameters: ActivateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    activateOrganization(requestParameters: ActivateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} contactId 
     * @param {IContactSaveClaimsTeamsDto} iContactSaveClaimsTeamsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    assignClaimsTeamsToContactRaw(requestParameters: AssignClaimsTeamsToContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    assignClaimsTeamsToContact(requestParameters: AssignClaimsTeamsToContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} claimsTeamId 
     * @param {IClaimsTeamSaveContactDto} iClaimsTeamSaveContactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    assignContactsToClaimsTeamRaw(requestParameters: AssignContactsToClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    assignContactsToClaimsTeam(requestParameters: AssignContactsToClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IClaimsTeamCreateDto} iClaimsTeamCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createClaimsTeamRaw(requestParameters: CreateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    createClaimsTeam(requestParameters: CreateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @param {IContactSaveDto} iContactSaveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createContactRaw(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>>;

    /**
     */
    createContact(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto>;

    /**
     * 
     * @summary Create express contact for external link
     * @param {IExpressContactSaveDto} iExpressContactSaveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createExpressContactRaw(requestParameters: CreateExpressContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>>;

    /**
     * Create express contact for external link
     */
    createExpressContact(requestParameters: CreateExpressContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto>;

    /**
     * 
     * @param {IOrganizationInfoDto} iOrganizationInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createOrganizationRaw(requestParameters: CreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationInfoDto>>;

    /**
     */
    createOrganization(requestParameters: CreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {number} addressId 
     * @param {IPreferredDto} iPreferredDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createOrganizationAddressRaw(requestParameters: CreateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPreferredDto>>;

    /**
     */
    createOrganizationAddress(requestParameters: CreateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPreferredDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IOrganizationPhoneInfoDto} iOrganizationPhoneInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createOrganizationPhoneRaw(requestParameters: CreateOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPhoneInfoDto>>;

    /**
     */
    createOrganizationPhone(requestParameters: CreateOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPhoneInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IOrganizationPropertyInfoDto} iOrganizationPropertyInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createOrganizationPropertyRaw(requestParameters: CreateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertyInfoDto>>;

    /**
     */
    createOrganizationProperty(requestParameters: CreateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertyInfoDto>;

    /**
     * 
     * @param {IVerificationCodeRequestCreateDto} iVerificationCodeRequestCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    createVerificationCodeRaw(requestParameters: CreateVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    createVerificationCode(requestParameters: CreateVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} claimsTeamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    deleteClaimsTeamRaw(requestParameters: DeleteClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClaimsTeam(requestParameters: DeleteClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    deleteTerminationSetupConfigRaw(requestParameters: DeleteTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteTerminationSetupConfig(requestParameters: DeleteTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    fetchTerminationSetupConfigRaw(requestParameters: FetchTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>>;

    /**
     */
    fetchTerminationSetupConfig(requestParameters: FetchTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findClaimsTeamsByContactRaw(requestParameters: FindClaimsTeamsByContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    findClaimsTeamsByContact(requestParameters: FindClaimsTeamsByContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @param {number} distributorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findExpressSetupPropertiesByDistributorRaw(requestParameters: FindExpressSetupPropertiesByDistributorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupInfoDto>>;

    /**
     */
    findExpressSetupPropertiesByDistributor(requestParameters: FindExpressSetupPropertiesByDistributorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findOrganizationNoteRaw(requestParameters: FindOrganizationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationNoteDto>>;

    /**
     */
    findOrganizationNote(requestParameters: FindOrganizationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationNoteDto>;

    /**
     * 
     * @param {string} hashId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findOrganizationPropertiesByHashIdRaw(requestParameters: FindOrganizationPropertiesByHashIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHashIdOverridablePropertiesDto>>;

    /**
     */
    findOrganizationPropertiesByHashId(requestParameters: FindOrganizationPropertiesByHashIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHashIdOverridablePropertiesDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findOrganizationPropertyRaw(requestParameters: FindOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertyInfoDto>>;

    /**
     */
    findOrganizationProperty(requestParameters: FindOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertyInfoDto>;

    /**
     * 
     * @param {number} accountManagerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findOrganizationsByAccountManagerIdRaw(requestParameters: FindOrganizationsByAccountManagerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationNameDto>>>;

    /**
     */
    findOrganizationsByAccountManagerId(requestParameters: FindOrganizationsByAccountManagerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationNameDto>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    findOrphanOrganizationsUnderPartnerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationShortDto>>>;

    /**
     */
    findOrphanOrganizationsUnderPartner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationShortDto>>;

    /**
     * 
     * @param {string} [searchValue] Get all contacts within organization
     * @param {number} [organizationId] 
     * @param {number} [claimsTeamId] 
     * @param {Set<number>} [permissionIds] 
     * @param {Set<number>} [type] 
     * @param {Set<number>} [ids] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getAllContactsRaw(requestParameters: GetAllContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContactInfoDto>>;

    /**
     */
    getAllContacts(requestParameters: GetAllContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContactInfoDto>;

    /**
     * 
     * @param {string} [searchValue] Get all contacts lite info
     * @param {number} [organizationId] 
     * @param {number} [claimsTeamId] 
     * @param {Set<number>} [ids] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getAllContactsLiteRaw(requestParameters: GetAllContactsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactInfoLiteDto>>>;

    /**
     */
    getAllContactsLite(requestParameters: GetAllContactsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactInfoLiteDto>>;

    /**
     * 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getAppealEligibleContactsRaw(requestParameters: GetAppealEligibleContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactInfoDto>>>;

    /**
     */
    getAppealEligibleContacts(requestParameters: GetAppealEligibleContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactInfoDto>>;

    /**
     * 
     * @summary Get all existing Bank Methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getBankMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBankMethodsDto>>;

    /**
     * Get all existing Bank Methods
     */
    getBankMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBankMethodsDto>;

    /**
     * 
     * @summary Get all existing Category types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getBusinessEntityTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBusinessEntityTypeDto>>>;

    /**
     * Get all existing Category types
     */
    getBusinessEntityTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBusinessEntityTypeDto>>;

    /**
     * 
     * @summary Get all existing check writing types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getCheckWritingTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICheckWritingTypeDto>>;

    /**
     * Get all existing check writing types
     */
    getCheckWritingTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICheckWritingTypeDto>;

    /**
     * 
     * @param {number} claimsTeamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getClaimsTeamRaw(requestParameters: GetClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    getClaimsTeam(requestParameters: GetClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getContactRaw(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactInfoDto>>>;

    /**
     */
    getContact(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactInfoDto>>;

    /**
     * 
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getContactCountRaw(requestParameters: GetContactCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactCountDto>>>;

    /**
     */
    getContactCount(requestParameters: GetContactCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactCountDto>>;

    /**
     * 
     * @param {Set<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getContactsRaw(requestParameters: GetContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactDataDto>>;

    /**
     */
    getContacts(requestParameters: GetContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactDataDto>;

    /**
     * 
     * @param {IContactByClaimsTeamsDto} iContactByClaimsTeamsDto 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getContactsByClaimTeamsRaw(requestParameters: GetContactsByClaimTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContactInfoDto>>;

    /**
     */
    getContactsByClaimTeams(requestParameters: GetContactsByClaimTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContactInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {'ACCOUNT_MANAGER'} [jobFunction] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getContactsUpHierarchyRaw(requestParameters: GetContactsUpHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContactInfoDto>>;

    /**
     */
    getContactsUpHierarchy(requestParameters: GetContactsUpHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContactInfoDto>;

    /**
     * 
     * @summary Get all existing electronic funding replenishments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getElectronicFundingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IElectronicFundingDto>>;

    /**
     * Get all existing electronic funding replenishments
     */
    getElectronicFunding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IElectronicFundingDto>;

    /**
     * 
     * @summary Get all existing eligible dependents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getEligibleDependentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEligibleDependentsDto>>;

    /**
     * Get all existing eligible dependents
     */
    getEligibleDependents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEligibleDependentsDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getEmployeeOverridablePropertiesRaw(requestParameters: GetEmployeeOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeOverridablePropertiesInfoDto>>;

    /**
     */
    getEmployeeOverridableProperties(requestParameters: GetEmployeeOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeOverridablePropertiesInfoDto>;

    /**
     * 
     * @summary Get all existing HSA custodian configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getHsaCustodianConfigsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHsaCustodianConfigDto>>>;

    /**
     * Get all existing HSA custodian configurations
     */
    getHsaCustodianConfigs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHsaCustodianConfigDto>>;

    /**
     * 
     * @summary Get all existing HSA custodian types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getHsaCustodiansTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHsaCustodianTypeDto>>>;

    /**
     * Get all existing HSA custodian types
     */
    getHsaCustodiansTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHsaCustodianTypeDto>>;

    /**
     * 
     * @summary Get all existing ID source types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getIdSourceTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIdSourceTypeDto>>>;

    /**
     * Get all existing ID source types
     */
    getIdSourceTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIdSourceTypeDto>>;

    /**
     * 
     * @summary Get mobile app themes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getMobileAppThemesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IMobileAppThemeDto>>>;

    /**
     * Get mobile app themes
     */
    getMobileAppThemes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IMobileAppThemeDto>>;

    /**
     * 
     * @param {number} organizationId 
     * @param {Set<IOrganizationResolverEnum>} [xDETAILSRESOLVERS] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationRaw(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationInfoDto>>;

    /**
     */
    getOrganization(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {number} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationAddressRaw(requestParameters: GetOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPreferredDto>>;

    /**
     */
    getOrganizationAddress(requestParameters: GetOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPreferredDto>;

    /**
     * 
     * @param {string} externalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationByExternalIdRaw(requestParameters: GetOrganizationByExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLiteDto>>;

    /**
     */
    getOrganizationByExternalId(requestParameters: GetOrganizationByExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLiteDto>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationByIdLiteRaw(requestParameters: GetOrganizationByIdLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationShortDto>>;

    /**
     */
    getOrganizationByIdLite(requestParameters: GetOrganizationByIdLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationShortDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationEmployeeViewRaw(requestParameters: GetOrganizationEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationViewDto>>;

    /**
     */
    getOrganizationEmployeeView(requestParameters: GetOrganizationEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationViewDto>;

    /**
     * 
     * @param {string} searchValue 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationHierarchyRaw(requestParameters: GetOrganizationHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHierarchyNode>>;

    /**
     */
    getOrganizationHierarchy(requestParameters: GetOrganizationHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHierarchyNode>;

    /**
     * 
     * @param {number} claimsTeamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationHierarchyByClaimsTeamRaw(requestParameters: GetOrganizationHierarchyByClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHierarchyNode>>;

    /**
     */
    getOrganizationHierarchyByClaimsTeam(requestParameters: GetOrganizationHierarchyByClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHierarchyNode>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationNameByIdRaw(requestParameters: GetOrganizationNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationNameDto>>>;

    /**
     */
    getOrganizationNameById(requestParameters: GetOrganizationNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationNameDto>>;

    /**
     * 
     * @param {Set<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationNamesByIdsRaw(requestParameters: GetOrganizationNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationNameDto>>>;

    /**
     */
    getOrganizationNamesByIds(requestParameters: GetOrganizationNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationNameDto>>;

    /**
     * 
     * @param {number} organizationId 
     * @param {number} phoneId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationPhoneRaw(requestParameters: GetOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPhoneInfoDto>>;

    /**
     */
    getOrganizationPhone(requestParameters: GetOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPhoneInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOrganizationPhonesRaw(requestParameters: GetOrganizationPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPhoneInfoDto>>;

    /**
     */
    getOrganizationPhones(requestParameters: GetOrganizationPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPhoneInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOverridablePropertiesRaw(requestParameters: GetOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOverridablePropertiesInfoDto>>;

    /**
     */
    getOverridableProperties(requestParameters: GetOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOverridablePropertiesInfoDto>;

    /**
     * 
     * @summary Return permissions for organization properties for current organization level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getOverridablePropertiesFieldsStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Return permissions for organization properties for current organization level
     */
    getOverridablePropertiesFieldsStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get all existing relationships types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    getRelationshipTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRelationshipTypeDto>>;

    /**
     * Get all existing relationships types
     */
    getRelationshipTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRelationshipTypeDto>;

    /**
     * 
     * @param {ILinkVerificationCodeValidationRequestDto} iLinkVerificationCodeValidationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    organizationVerifyCodeFromLinkRaw(requestParameters: OrganizationVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeValidationResponseDto>>;

    /**
     */
    organizationVerifyCodeFromLink(requestParameters: OrganizationVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeValidationResponseDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IPropagateOverridablePropertiesRequest} iPropagateOverridablePropertiesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    propagateOverridablePropertiesRaw(requestParameters: PropagateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPropagateOverridablePropertiesResponse>>;

    /**
     */
    propagateOverridableProperties(requestParameters: PropagateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPropagateOverridablePropertiesResponse>;

    /**
     * Reactivate organization
     * @param {number} organizationId 
     * @param {IOrganizationReactivationRequest} iOrganizationReactivationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    reactivateRaw(requestParameters: ReactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reactivate organization
     */
    reactivate(requestParameters: ReactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} organizationId 
     * @param {Blob} file logo file to be uploaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    saveOrganizationCustomEmailTemplateLogoRaw(requestParameters: SaveOrganizationCustomEmailTemplateLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationEmailTemplateLogoDto>>;

    /**
     */
    saveOrganizationCustomEmailTemplateLogo(requestParameters: SaveOrganizationCustomEmailTemplateLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationEmailTemplateLogoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {'LARGE' | 'MINIMIZED' | 'FAVICON' | 'DARK_LARGE' | 'DARK_MINIMIZED'} logoType 
     * @param {Blob} file logo file to be uploaded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    saveOrganizationLogoRaw(requestParameters: SaveOrganizationLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLogoDto>>;

    /**
     */
    saveOrganizationLogo(requestParameters: SaveOrganizationLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLogoDto>;

    /**
     * 
     * @param {{ [key: string]: Array<IClaimsByServiceSearchDto>; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    searchAllClaimTeamsByOrgPathAndServiceIdRaw(requestParameters: SearchAllClaimTeamsByOrgPathAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    searchAllClaimTeamsByOrgPathAndServiceId(requestParameters: SearchAllClaimTeamsByOrgPathAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @param {string} [claimsTeamName] 
     * @param {number} [contactId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    searchClaimsTeamsRaw(requestParameters: SearchClaimsTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    searchClaimsTeams(requestParameters: SearchClaimsTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @summary Get email illustrations
     * @param {string} orgPath Search email illustrations by orgPath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    searchEmailIllustrationsRaw(requestParameters: SearchEmailIllustrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmailIllustrationDto>>>;

    /**
     * Get email illustrations
     */
    searchEmailIllustrations(requestParameters: SearchEmailIllustrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmailIllustrationDto>>;

    /**
     * 
     * @param {IClaimsTeamCreateDto} iClaimsTeamCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    searchOrganizationServiceIntersectionRaw(requestParameters: SearchOrganizationServiceIntersectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    searchOrganizationServiceIntersection(requestParameters: SearchOrganizationServiceIntersectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @param {string} organizationName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    searchOrganizationsWithSubsidiariesRaw(requestParameters: SearchOrganizationsWithSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>>;

    /**
     */
    searchOrganizationsWithSubsidiaries(requestParameters: SearchOrganizationsWithSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>>;

    /**
     * 
     * @param {ISearchOrganizationDto} iSearchOrganizationDto 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    searchShortOrganizationsRaw(requestParameters: SearchShortOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageOrganizationShortDto>>;

    /**
     */
    searchShortOrganizations(requestParameters: SearchShortOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageOrganizationShortDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    unassignAllAccountManagerRolesRaw(requestParameters: UnassignAllAccountManagerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>>;

    /**
     */
    unassignAllAccountManagerRoles(requestParameters: UnassignAllAccountManagerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto>;

    /**
     * 
     * @param {number} claimsTeamId 
     * @param {IClaimsTeamUpdateDto} iClaimsTeamUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateClaimsTeamRaw(requestParameters: UpdateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>>;

    /**
     */
    updateClaimsTeam(requestParameters: UpdateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {boolean} clockIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateClockInRaw(requestParameters: UpdateClockInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>>;

    /**
     */
    updateClockIn(requestParameters: UpdateClockInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {IContactSaveDto} iContactSaveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateContactRaw(requestParameters: UpdateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>>;

    /**
     */
    updateContact(requestParameters: UpdateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {IExpressContactStatusDto} iExpressContactStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateContactStatusRaw(requestParameters: UpdateContactStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>>;

    /**
     */
    updateContactStatus(requestParameters: UpdateContactStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IOrganizationInfoDto} iOrganizationInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateOrganizationRaw(requestParameters: UpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationInfoDto>>;

    /**
     */
    updateOrganization(requestParameters: UpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {number} addressId 
     * @param {IPreferredDto} iPreferredDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateOrganizationAddressRaw(requestParameters: UpdateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPreferredDto>>;

    /**
     */
    updateOrganizationAddress(requestParameters: UpdateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPreferredDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {INotificationPropertiesInfoDto} iNotificationPropertiesInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateOrganizationNotificationPropertiesRaw(requestParameters: UpdateOrganizationNotificationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateOrganizationNotificationProperties(requestParameters: UpdateOrganizationNotificationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IOrganizationPropertyInfoDto} iOrganizationPropertyInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateOrganizationPropertyRaw(requestParameters: UpdateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertyInfoDto>>;

    /**
     */
    updateOrganizationProperty(requestParameters: UpdateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertyInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {'PENDING' | 'ACTIVE' | 'TERMINATED' | 'ACTIVATION_FAILED' | 'PENDING_TERMINATION' | 'EXPRESS_SETUP' | 'ABANDONED' | 'TERMINATION_IN_PROGRESS' | 'PENDING_REACTIVATION'} status 
     * @param {boolean} [isExpressSetupActivation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateOrganizationStatusRaw(requestParameters: UpdateOrganizationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateOrganizationStatus(requestParameters: UpdateOrganizationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IOverridablePropertiesInfoDto} iOverridablePropertiesInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    updateOverridablePropertyRaw(requestParameters: UpdateOverridablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOverridablePropertiesInfoDto>>;

    /**
     */
    updateOverridableProperty(requestParameters: UpdateOverridablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOverridablePropertiesInfoDto>;

    /**
     * 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    validateOrganizationToCreateEmployeeRaw(requestParameters: ValidateOrganizationToCreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    validateOrganizationToCreateEmployee(requestParameters: ValidateOrganizationToCreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} organizationId 
     * @param {IOverridablePropertiesInfoDto} iOverridablePropertiesInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    validateOverridablePropertiesRaw(requestParameters: ValidateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOverridablePropertiesValidateDto>>;

    /**
     */
    validateOverridableProperties(requestParameters: ValidateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOverridablePropertiesValidateDto>;

    /**
     * 
     * @param {Set<string>} names 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationServiceServiceApiInterface
     */
    validateUserNameNotExistsRaw(requestParameters: ValidateUserNameNotExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    validateUserNameNotExists(requestParameters: ValidateUserNameNotExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class OrganizationServiceServiceApi extends runtime.BaseAPI implements OrganizationServiceServiceApiInterface {

    /**
     */
    async activateOrganizationRaw(requestParameters: ActivateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling activateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/activate`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async activateOrganization(requestParameters: ActivateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.activateOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assignClaimsTeamsToContactRaw(requestParameters: AssignClaimsTeamsToContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling assignClaimsTeamsToContact().'
            );
        }

        if (requestParameters['iContactSaveClaimsTeamsDto'] == null) {
            throw new runtime.RequiredError(
                'iContactSaveClaimsTeamsDto',
                'Required parameter "iContactSaveClaimsTeamsDto" was null or undefined when calling assignClaimsTeamsToContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}/claims-teams`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IContactSaveClaimsTeamsDtoToJSON(requestParameters['iContactSaveClaimsTeamsDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assignClaimsTeamsToContact(requestParameters: AssignClaimsTeamsToContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignClaimsTeamsToContactRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assignContactsToClaimsTeamRaw(requestParameters: AssignContactsToClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimsTeamId'] == null) {
            throw new runtime.RequiredError(
                'claimsTeamId',
                'Required parameter "claimsTeamId" was null or undefined when calling assignContactsToClaimsTeam().'
            );
        }

        if (requestParameters['iClaimsTeamSaveContactDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimsTeamSaveContactDto',
                'Required parameter "iClaimsTeamSaveContactDto" was null or undefined when calling assignContactsToClaimsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams/{claims-team-id}/contacts`;
        urlPath = urlPath.replace(`{${"claims-team-id"}}`, encodeURIComponent(String(requestParameters['claimsTeamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimsTeamSaveContactDtoToJSON(requestParameters['iClaimsTeamSaveContactDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assignContactsToClaimsTeam(requestParameters: AssignContactsToClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignContactsToClaimsTeamRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createClaimsTeamRaw(requestParameters: CreateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        if (requestParameters['iClaimsTeamCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimsTeamCreateDto',
                'Required parameter "iClaimsTeamCreateDto" was null or undefined when calling createClaimsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimsTeamCreateDtoToJSON(requestParameters['iClaimsTeamCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async createClaimsTeam(requestParameters: CreateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.createClaimsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createContactRaw(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>> {
        if (requestParameters['iContactSaveDto'] == null) {
            throw new runtime.RequiredError(
                'iContactSaveDto',
                'Required parameter "iContactSaveDto" was null or undefined when calling createContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IContactSaveDtoToJSON(requestParameters['iContactSaveDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async createContact(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto> {
        const response = await this.createContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create express contact for external link
     */
    async createExpressContactRaw(requestParameters: CreateExpressContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>> {
        if (requestParameters['iExpressContactSaveDto'] == null) {
            throw new runtime.RequiredError(
                'iExpressContactSaveDto',
                'Required parameter "iExpressContactSaveDto" was null or undefined when calling createExpressContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/express-setup/contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IExpressContactSaveDtoToJSON(requestParameters['iExpressContactSaveDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactInfoDtoFromJSON(jsonValue));
    }

    /**
     * Create express contact for external link
     */
    async createExpressContact(requestParameters: CreateExpressContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto> {
        const response = await this.createExpressContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOrganizationRaw(requestParameters: CreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationInfoDto>> {
        if (requestParameters['iOrganizationInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationInfoDto',
                'Required parameter "iOrganizationInfoDto" was null or undefined when calling createOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationInfoDtoToJSON(requestParameters['iOrganizationInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async createOrganization(requestParameters: CreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationInfoDto> {
        const response = await this.createOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOrganizationAddressRaw(requestParameters: CreateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPreferredDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createOrganizationAddress().'
            );
        }

        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError(
                'addressId',
                'Required parameter "addressId" was null or undefined when calling createOrganizationAddress().'
            );
        }

        if (requestParameters['iPreferredDto'] == null) {
            throw new runtime.RequiredError(
                'iPreferredDto',
                'Required parameter "iPreferredDto" was null or undefined when calling createOrganizationAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/addresses/{address-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"address-id"}}`, encodeURIComponent(String(requestParameters['addressId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPreferredDtoToJSON(requestParameters['iPreferredDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPreferredDtoFromJSON(jsonValue));
    }

    /**
     */
    async createOrganizationAddress(requestParameters: CreateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPreferredDto> {
        const response = await this.createOrganizationAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOrganizationPhoneRaw(requestParameters: CreateOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPhoneInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createOrganizationPhone().'
            );
        }

        if (requestParameters['iOrganizationPhoneInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationPhoneInfoDto',
                'Required parameter "iOrganizationPhoneInfoDto" was null or undefined when calling createOrganizationPhone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/phones`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationPhoneInfoDtoToJSON(requestParameters['iOrganizationPhoneInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPhoneInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async createOrganizationPhone(requestParameters: CreateOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPhoneInfoDto> {
        const response = await this.createOrganizationPhoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOrganizationPropertyRaw(requestParameters: CreateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertyInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling createOrganizationProperty().'
            );
        }

        if (requestParameters['iOrganizationPropertyInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationPropertyInfoDto',
                'Required parameter "iOrganizationPropertyInfoDto" was null or undefined when calling createOrganizationProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/properties`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationPropertyInfoDtoToJSON(requestParameters['iOrganizationPropertyInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertyInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async createOrganizationProperty(requestParameters: CreateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertyInfoDto> {
        const response = await this.createOrganizationPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createVerificationCodeRaw(requestParameters: CreateVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iVerificationCodeRequestCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iVerificationCodeRequestCreateDto',
                'Required parameter "iVerificationCodeRequestCreateDto" was null or undefined when calling createVerificationCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/verification-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IVerificationCodeRequestCreateDtoToJSON(requestParameters['iVerificationCodeRequestCreateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createVerificationCode(requestParameters: CreateVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createVerificationCodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteClaimsTeamRaw(requestParameters: DeleteClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimsTeamId'] == null) {
            throw new runtime.RequiredError(
                'claimsTeamId',
                'Required parameter "claimsTeamId" was null or undefined when calling deleteClaimsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams/{claims-team-id}`;
        urlPath = urlPath.replace(`{${"claims-team-id"}}`, encodeURIComponent(String(requestParameters['claimsTeamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClaimsTeam(requestParameters: DeleteClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimsTeamRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTerminationSetupConfigRaw(requestParameters: DeleteTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling deleteTerminationSetupConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/termination`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTerminationSetupConfig(requestParameters: DeleteTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTerminationSetupConfigRaw(requestParameters, initOverrides);
    }

    /**
     */
    async fetchTerminationSetupConfigRaw(requestParameters: FetchTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerTerminationPropertiesDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling fetchTerminationSetupConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/termination`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployerTerminationPropertiesDtoFromJSON(jsonValue));
    }

    /**
     */
    async fetchTerminationSetupConfig(requestParameters: FetchTerminationSetupConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerTerminationPropertiesDto> {
        const response = await this.fetchTerminationSetupConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findClaimsTeamsByContactRaw(requestParameters: FindClaimsTeamsByContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling findClaimsTeamsByContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}/claims-teams`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async findClaimsTeamsByContact(requestParameters: FindClaimsTeamsByContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.findClaimsTeamsByContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findExpressSetupPropertiesByDistributorRaw(requestParameters: FindExpressSetupPropertiesByDistributorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExpressSetupInfoDto>> {
        if (requestParameters['distributorId'] == null) {
            throw new runtime.RequiredError(
                'distributorId',
                'Required parameter "distributorId" was null or undefined when calling findExpressSetupPropertiesByDistributor().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['distributorId'] != null) {
            queryParameters['distributor_id'] = requestParameters['distributorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/express-setup/enabled`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExpressSetupInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async findExpressSetupPropertiesByDistributor(requestParameters: FindExpressSetupPropertiesByDistributorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExpressSetupInfoDto> {
        const response = await this.findExpressSetupPropertiesByDistributorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findOrganizationNoteRaw(requestParameters: FindOrganizationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationNoteDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling findOrganizationNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/notes`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationNoteDtoFromJSON(jsonValue));
    }

    /**
     */
    async findOrganizationNote(requestParameters: FindOrganizationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationNoteDto> {
        const response = await this.findOrganizationNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findOrganizationPropertiesByHashIdRaw(requestParameters: FindOrganizationPropertiesByHashIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHashIdOverridablePropertiesDto>> {
        if (requestParameters['hashId'] == null) {
            throw new runtime.RequiredError(
                'hashId',
                'Required parameter "hashId" was null or undefined when calling findOrganizationPropertiesByHashId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organization-properties/hash/{hash-id}`;
        urlPath = urlPath.replace(`{${"hash-id"}}`, encodeURIComponent(String(requestParameters['hashId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHashIdOverridablePropertiesDtoFromJSON(jsonValue));
    }

    /**
     */
    async findOrganizationPropertiesByHashId(requestParameters: FindOrganizationPropertiesByHashIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHashIdOverridablePropertiesDto> {
        const response = await this.findOrganizationPropertiesByHashIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findOrganizationPropertyRaw(requestParameters: FindOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertyInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling findOrganizationProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/properties`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertyInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async findOrganizationProperty(requestParameters: FindOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertyInfoDto> {
        const response = await this.findOrganizationPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findOrganizationsByAccountManagerIdRaw(requestParameters: FindOrganizationsByAccountManagerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationNameDto>>> {
        if (requestParameters['accountManagerId'] == null) {
            throw new runtime.RequiredError(
                'accountManagerId',
                'Required parameter "accountManagerId" was null or undefined when calling findOrganizationsByAccountManagerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/account-manager/{account-manager-id}`;
        urlPath = urlPath.replace(`{${"account-manager-id"}}`, encodeURIComponent(String(requestParameters['accountManagerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IOrganizationNameDtoFromJSON));
    }

    /**
     */
    async findOrganizationsByAccountManagerId(requestParameters: FindOrganizationsByAccountManagerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationNameDto>> {
        const response = await this.findOrganizationsByAccountManagerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findOrphanOrganizationsUnderPartnerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationShortDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/orphan`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IOrganizationShortDtoFromJSON));
    }

    /**
     */
    async findOrphanOrganizationsUnderPartner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationShortDto>> {
        const response = await this.findOrphanOrganizationsUnderPartnerRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllContactsRaw(requestParameters: GetAllContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContactInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['claimsTeamId'] != null) {
            queryParameters['claims_team_id'] = requestParameters['claimsTeamId'];
        }

        if (requestParameters['permissionIds'] != null) {
            queryParameters['permission_ids'] = requestParameters['permissionIds'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getAllContacts(requestParameters: GetAllContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContactInfoDto> {
        const response = await this.getAllContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllContactsLiteRaw(requestParameters: GetAllContactsLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactInfoLiteDto>>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['claimsTeamId'] != null) {
            queryParameters['claims_team_id'] = requestParameters['claimsTeamId'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/all/lite`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContactInfoLiteDtoFromJSON));
    }

    /**
     */
    async getAllContactsLite(requestParameters: GetAllContactsLiteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactInfoLiteDto>> {
        const response = await this.getAllContactsLiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAppealEligibleContactsRaw(requestParameters: GetAppealEligibleContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactInfoDto>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/appeal-eligible`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContactInfoDtoFromJSON));
    }

    /**
     */
    async getAppealEligibleContacts(requestParameters: GetAppealEligibleContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactInfoDto>> {
        const response = await this.getAppealEligibleContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing Bank Methods
     */
    async getBankMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBankMethodsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/bank-methods`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IBankMethodsDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing Bank Methods
     */
    async getBankMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBankMethodsDto> {
        const response = await this.getBankMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing Category types
     */
    async getBusinessEntityTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBusinessEntityTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/business-entity-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IBusinessEntityTypeDtoFromJSON));
    }

    /**
     * Get all existing Category types
     */
    async getBusinessEntityTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBusinessEntityTypeDto>> {
        const response = await this.getBusinessEntityTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing check writing types
     */
    async getCheckWritingTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICheckWritingTypeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/check-writings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICheckWritingTypeDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing check writing types
     */
    async getCheckWritingTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICheckWritingTypeDto> {
        const response = await this.getCheckWritingTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getClaimsTeamRaw(requestParameters: GetClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        if (requestParameters['claimsTeamId'] == null) {
            throw new runtime.RequiredError(
                'claimsTeamId',
                'Required parameter "claimsTeamId" was null or undefined when calling getClaimsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams/{claims-team-id}`;
        urlPath = urlPath.replace(`{${"claims-team-id"}}`, encodeURIComponent(String(requestParameters['claimsTeamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getClaimsTeam(requestParameters: GetClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.getClaimsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactRaw(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactInfoDto>>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContactInfoDtoFromJSON));
    }

    /**
     */
    async getContact(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactInfoDto>> {
        const response = await this.getContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactCountRaw(requestParameters: GetContactCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IContactCountDto>>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling getContactCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['roleId'] != null) {
            queryParameters['role_id'] = requestParameters['roleId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/count-by-role`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IContactCountDtoFromJSON));
    }

    /**
     */
    async getContactCount(requestParameters: GetContactCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IContactCountDto>> {
        const response = await this.getContactCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactsRaw(requestParameters: GetContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactDataDto>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getContacts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactDataDtoFromJSON(jsonValue));
    }

    /**
     */
    async getContacts(requestParameters: GetContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactDataDto> {
        const response = await this.getContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactsByClaimTeamsRaw(requestParameters: GetContactsByClaimTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContactInfoDto>> {
        if (requestParameters['iContactByClaimsTeamsDto'] == null) {
            throw new runtime.RequiredError(
                'iContactByClaimsTeamsDto',
                'Required parameter "iContactByClaimsTeamsDto" was null or undefined when calling getContactsByClaimTeams().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/teams`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IContactByClaimsTeamsDtoToJSON(requestParameters['iContactByClaimsTeamsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getContactsByClaimTeams(requestParameters: GetContactsByClaimTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContactInfoDto> {
        const response = await this.getContactsByClaimTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactsUpHierarchyRaw(requestParameters: GetContactsUpHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContactInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getContactsUpHierarchy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['jobFunction'] != null) {
            queryParameters['job_function'] = requestParameters['jobFunction'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/up-hierarchy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getContactsUpHierarchy(requestParameters: GetContactsUpHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContactInfoDto> {
        const response = await this.getContactsUpHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing electronic funding replenishments
     */
    async getElectronicFundingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IElectronicFundingDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/electronic-funding-replenishments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IElectronicFundingDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing electronic funding replenishments
     */
    async getElectronicFunding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IElectronicFundingDto> {
        const response = await this.getElectronicFundingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing eligible dependents
     */
    async getEligibleDependentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEligibleDependentsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/eligible-dependents`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEligibleDependentsDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing eligible dependents
     */
    async getEligibleDependents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEligibleDependentsDto> {
        const response = await this.getEligibleDependentsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmployeeOverridablePropertiesRaw(requestParameters: GetEmployeeOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeOverridablePropertiesInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getEmployeeOverridableProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/overridable-properties/employee`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeOverridablePropertiesInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getEmployeeOverridableProperties(requestParameters: GetEmployeeOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeOverridablePropertiesInfoDto> {
        const response = await this.getEmployeeOverridablePropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing HSA custodian configurations
     */
    async getHsaCustodianConfigsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHsaCustodianConfigDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/hsa-custodian-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHsaCustodianConfigDtoFromJSON));
    }

    /**
     * Get all existing HSA custodian configurations
     */
    async getHsaCustodianConfigs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHsaCustodianConfigDto>> {
        const response = await this.getHsaCustodianConfigsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing HSA custodian types
     */
    async getHsaCustodiansTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IHsaCustodianTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/hsa-custodians`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IHsaCustodianTypeDtoFromJSON));
    }

    /**
     * Get all existing HSA custodian types
     */
    async getHsaCustodiansTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IHsaCustodianTypeDto>> {
        const response = await this.getHsaCustodiansTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing ID source types
     */
    async getIdSourceTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IIdSourceTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/source-ids`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IIdSourceTypeDtoFromJSON));
    }

    /**
     * Get all existing ID source types
     */
    async getIdSourceTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IIdSourceTypeDto>> {
        const response = await this.getIdSourceTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get mobile app themes
     */
    async getMobileAppThemesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IMobileAppThemeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mobile-themes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IMobileAppThemeDtoFromJSON));
    }

    /**
     * Get mobile app themes
     */
    async getMobileAppThemes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IMobileAppThemeDto>> {
        const response = await this.getMobileAppThemesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationRaw(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xDETAILSRESOLVERS'] != null) {
            headerParameters['X-DETAILS-RESOLVERS'] = Array.from(requestParameters['xDETAILSRESOLVERS'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganization(requestParameters: GetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationInfoDto> {
        const response = await this.getOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationAddressRaw(requestParameters: GetOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPreferredDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationAddress().'
            );
        }

        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError(
                'addressId',
                'Required parameter "addressId" was null or undefined when calling getOrganizationAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/addresses/{address-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"address-id"}}`, encodeURIComponent(String(requestParameters['addressId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPreferredDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationAddress(requestParameters: GetOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPreferredDto> {
        const response = await this.getOrganizationAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationByExternalIdRaw(requestParameters: GetOrganizationByExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLiteDto>> {
        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling getOrganizationByExternalId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/external-id/{external-id}`;
        urlPath = urlPath.replace(`{${"external-id"}}`, encodeURIComponent(String(requestParameters['externalId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationLiteDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationByExternalId(requestParameters: GetOrganizationByExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLiteDto> {
        const response = await this.getOrganizationByExternalIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationByIdLiteRaw(requestParameters: GetOrganizationByIdLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationShortDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationByIdLite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{id}/short`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationShortDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationByIdLite(requestParameters: GetOrganizationByIdLiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationShortDto> {
        const response = await this.getOrganizationByIdLiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationEmployeeViewRaw(requestParameters: GetOrganizationEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationViewDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationEmployeeView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/employee-view`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationViewDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationEmployeeView(requestParameters: GetOrganizationEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationViewDto> {
        const response = await this.getOrganizationEmployeeViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationHierarchyRaw(requestParameters: GetOrganizationHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHierarchyNode>> {
        if (requestParameters['searchValue'] == null) {
            throw new runtime.RequiredError(
                'searchValue',
                'Required parameter "searchValue" was null or undefined when calling getOrganizationHierarchy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/hierarchy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHierarchyNodeFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationHierarchy(requestParameters: GetOrganizationHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHierarchyNode> {
        const response = await this.getOrganizationHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationHierarchyByClaimsTeamRaw(requestParameters: GetOrganizationHierarchyByClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHierarchyNode>> {
        if (requestParameters['claimsTeamId'] == null) {
            throw new runtime.RequiredError(
                'claimsTeamId',
                'Required parameter "claimsTeamId" was null or undefined when calling getOrganizationHierarchyByClaimsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/claims-team/{claims-team-id}/hierarchy`;
        urlPath = urlPath.replace(`{${"claims-team-id"}}`, encodeURIComponent(String(requestParameters['claimsTeamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHierarchyNodeFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationHierarchyByClaimsTeam(requestParameters: GetOrganizationHierarchyByClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHierarchyNode> {
        const response = await this.getOrganizationHierarchyByClaimsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationNameByIdRaw(requestParameters: GetOrganizationNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationNameDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationNameById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{id}/name`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IOrganizationNameDtoFromJSON));
    }

    /**
     */
    async getOrganizationNameById(requestParameters: GetOrganizationNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationNameDto>> {
        const response = await this.getOrganizationNameByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationNamesByIdsRaw(requestParameters: GetOrganizationNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IOrganizationNameDto>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getOrganizationNamesByIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/names`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IOrganizationNameDtoFromJSON));
    }

    /**
     */
    async getOrganizationNamesByIds(requestParameters: GetOrganizationNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IOrganizationNameDto>> {
        const response = await this.getOrganizationNamesByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationPhoneRaw(requestParameters: GetOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPhoneInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationPhone().'
            );
        }

        if (requestParameters['phoneId'] == null) {
            throw new runtime.RequiredError(
                'phoneId',
                'Required parameter "phoneId" was null or undefined when calling getOrganizationPhone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/phones/{phone-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"phone-id"}}`, encodeURIComponent(String(requestParameters['phoneId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPhoneInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationPhone(requestParameters: GetOrganizationPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPhoneInfoDto> {
        const response = await this.getOrganizationPhoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrganizationPhonesRaw(requestParameters: GetOrganizationPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPhoneInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationPhones().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/phones`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPhoneInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOrganizationPhones(requestParameters: GetOrganizationPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPhoneInfoDto> {
        const response = await this.getOrganizationPhonesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOverridablePropertiesRaw(requestParameters: GetOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOverridablePropertiesInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOverridableProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/overridable-properties`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOverridablePropertiesInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getOverridableProperties(requestParameters: GetOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOverridablePropertiesInfoDto> {
        const response = await this.getOverridablePropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return permissions for organization properties for current organization level
     */
    async getOverridablePropertiesFieldsStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/overridable-properties-field-state`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Return permissions for organization properties for current organization level
     */
    async getOverridablePropertiesFieldsStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getOverridablePropertiesFieldsStatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing relationships types
     */
    async getRelationshipTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRelationshipTypeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/relationship-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRelationshipTypeDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing relationships types
     */
    async getRelationshipTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRelationshipTypeDto> {
        const response = await this.getRelationshipTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationVerifyCodeFromLinkRaw(requestParameters: OrganizationVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeValidationResponseDto>> {
        if (requestParameters['iLinkVerificationCodeValidationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iLinkVerificationCodeValidationRequestDto',
                'Required parameter "iLinkVerificationCodeValidationRequestDto" was null or undefined when calling organizationVerifyCodeFromLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/contacts/email/verifications`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ILinkVerificationCodeValidationRequestDtoToJSON(requestParameters['iLinkVerificationCodeValidationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IVerificationCodeValidationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationVerifyCodeFromLink(requestParameters: OrganizationVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeValidationResponseDto> {
        const response = await this.organizationVerifyCodeFromLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async propagateOverridablePropertiesRaw(requestParameters: PropagateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPropagateOverridablePropertiesResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling propagateOverridableProperties().'
            );
        }

        if (requestParameters['iPropagateOverridablePropertiesRequest'] == null) {
            throw new runtime.RequiredError(
                'iPropagateOverridablePropertiesRequest',
                'Required parameter "iPropagateOverridablePropertiesRequest" was null or undefined when calling propagateOverridableProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/overridable-properties/propagate`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPropagateOverridablePropertiesRequestToJSON(requestParameters['iPropagateOverridablePropertiesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPropagateOverridablePropertiesResponseFromJSON(jsonValue));
    }

    /**
     */
    async propagateOverridableProperties(requestParameters: PropagateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPropagateOverridablePropertiesResponse> {
        const response = await this.propagateOverridablePropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reactivate organization
     */
    async reactivateRaw(requestParameters: ReactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling reactivate().'
            );
        }

        if (requestParameters['iOrganizationReactivationRequest'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationReactivationRequest',
                'Required parameter "iOrganizationReactivationRequest" was null or undefined when calling reactivate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/reactivation`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationReactivationRequestToJSON(requestParameters['iOrganizationReactivationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivate organization
     */
    async reactivate(requestParameters: ReactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reactivateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async saveOrganizationCustomEmailTemplateLogoRaw(requestParameters: SaveOrganizationCustomEmailTemplateLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationEmailTemplateLogoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling saveOrganizationCustomEmailTemplateLogo().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling saveOrganizationCustomEmailTemplateLogo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization-id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/organizations/logo/email-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationEmailTemplateLogoDtoFromJSON(jsonValue));
    }

    /**
     */
    async saveOrganizationCustomEmailTemplateLogo(requestParameters: SaveOrganizationCustomEmailTemplateLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationEmailTemplateLogoDto> {
        const response = await this.saveOrganizationCustomEmailTemplateLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveOrganizationLogoRaw(requestParameters: SaveOrganizationLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationLogoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling saveOrganizationLogo().'
            );
        }

        if (requestParameters['logoType'] == null) {
            throw new runtime.RequiredError(
                'logoType',
                'Required parameter "logoType" was null or undefined when calling saveOrganizationLogo().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling saveOrganizationLogo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization-id'] = requestParameters['organizationId'];
        }

        if (requestParameters['logoType'] != null) {
            queryParameters['logo-type'] = requestParameters['logoType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/organizations/logo`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationLogoDtoFromJSON(jsonValue));
    }

    /**
     */
    async saveOrganizationLogo(requestParameters: SaveOrganizationLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationLogoDto> {
        const response = await this.saveOrganizationLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchAllClaimTeamsByOrgPathAndServiceIdRaw(requestParameters: SearchAllClaimTeamsByOrgPathAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling searchAllClaimTeamsByOrgPathAndServiceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchAllClaimTeamsByOrgPathAndServiceId(requestParameters: SearchAllClaimTeamsByOrgPathAndServiceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.searchAllClaimTeamsByOrgPathAndServiceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchClaimsTeamsRaw(requestParameters: SearchClaimsTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['claimsTeamName'] != null) {
            queryParameters['claims_team_name'] = requestParameters['claimsTeamName'];
        }

        if (requestParameters['contactId'] != null) {
            queryParameters['contact_id'] = requestParameters['contactId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchClaimsTeams(requestParameters: SearchClaimsTeamsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.searchClaimsTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get email illustrations
     */
    async searchEmailIllustrationsRaw(requestParameters: SearchEmailIllustrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmailIllustrationDto>>> {
        if (requestParameters['orgPath'] == null) {
            throw new runtime.RequiredError(
                'orgPath',
                'Required parameter "orgPath" was null or undefined when calling searchEmailIllustrations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orgPath'] != null) {
            queryParameters['org_path'] = requestParameters['orgPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/email-illustrations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEmailIllustrationDtoFromJSON));
    }

    /**
     * Get email illustrations
     */
    async searchEmailIllustrations(requestParameters: SearchEmailIllustrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmailIllustrationDto>> {
        const response = await this.searchEmailIllustrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchOrganizationServiceIntersectionRaw(requestParameters: SearchOrganizationServiceIntersectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        if (requestParameters['iClaimsTeamCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimsTeamCreateDto',
                'Required parameter "iClaimsTeamCreateDto" was null or undefined when calling searchOrganizationServiceIntersection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams/search-assigned`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimsTeamCreateDtoToJSON(requestParameters['iClaimsTeamCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchOrganizationServiceIntersection(requestParameters: SearchOrganizationServiceIntersectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.searchOrganizationServiceIntersectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchOrganizationsWithSubsidiariesRaw(requestParameters: SearchOrganizationsWithSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters['organizationName'] == null) {
            throw new runtime.RequiredError(
                'organizationName',
                'Required parameter "organizationName" was null or undefined when calling searchOrganizationsWithSubsidiaries().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationName'] != null) {
            queryParameters['organizationName'] = requestParameters['organizationName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/subsidiaries`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async searchOrganizationsWithSubsidiaries(requestParameters: SearchOrganizationsWithSubsidiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.searchOrganizationsWithSubsidiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchShortOrganizationsRaw(requestParameters: SearchShortOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageOrganizationShortDto>> {
        if (requestParameters['iSearchOrganizationDto'] == null) {
            throw new runtime.RequiredError(
                'iSearchOrganizationDto',
                'Required parameter "iSearchOrganizationDto" was null or undefined when calling searchShortOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/short`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ISearchOrganizationDtoToJSON(requestParameters['iSearchOrganizationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageOrganizationShortDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchShortOrganizations(requestParameters: SearchShortOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageOrganizationShortDto> {
        const response = await this.searchShortOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unassignAllAccountManagerRolesRaw(requestParameters: UnassignAllAccountManagerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling unassignAllAccountManagerRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}/unassign-account-manager`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async unassignAllAccountManagerRoles(requestParameters: UnassignAllAccountManagerRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto> {
        const response = await this.unassignAllAccountManagerRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClaimsTeamRaw(requestParameters: UpdateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsTeamInfoDto>> {
        if (requestParameters['claimsTeamId'] == null) {
            throw new runtime.RequiredError(
                'claimsTeamId',
                'Required parameter "claimsTeamId" was null or undefined when calling updateClaimsTeam().'
            );
        }

        if (requestParameters['iClaimsTeamUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimsTeamUpdateDto',
                'Required parameter "iClaimsTeamUpdateDto" was null or undefined when calling updateClaimsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims-teams/{claims-team-id}`;
        urlPath = urlPath.replace(`{${"claims-team-id"}}`, encodeURIComponent(String(requestParameters['claimsTeamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimsTeamUpdateDtoToJSON(requestParameters['iClaimsTeamUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsTeamInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateClaimsTeam(requestParameters: UpdateClaimsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsTeamInfoDto> {
        const response = await this.updateClaimsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClockInRaw(requestParameters: UpdateClockInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling updateClockIn().'
            );
        }

        if (requestParameters['clockIn'] == null) {
            throw new runtime.RequiredError(
                'clockIn',
                'Required parameter "clockIn" was null or undefined when calling updateClockIn().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clockIn'] != null) {
            queryParameters['clockIn'] = requestParameters['clockIn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}/clock-in`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateClockIn(requestParameters: UpdateClockInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto> {
        const response = await this.updateClockInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateContactRaw(requestParameters: UpdateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling updateContact().'
            );
        }

        if (requestParameters['iContactSaveDto'] == null) {
            throw new runtime.RequiredError(
                'iContactSaveDto',
                'Required parameter "iContactSaveDto" was null or undefined when calling updateContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IContactSaveDtoToJSON(requestParameters['iContactSaveDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateContact(requestParameters: UpdateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto> {
        const response = await this.updateContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateContactStatusRaw(requestParameters: UpdateContactStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContactInfoDto>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling updateContactStatus().'
            );
        }

        if (requestParameters['iExpressContactStatusDto'] == null) {
            throw new runtime.RequiredError(
                'iExpressContactStatusDto',
                'Required parameter "iExpressContactStatusDto" was null or undefined when calling updateContactStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/{contact-id}/express`;
        urlPath = urlPath.replace(`{${"contact-id"}}`, encodeURIComponent(String(requestParameters['contactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IExpressContactStatusDtoToJSON(requestParameters['iExpressContactStatusDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContactInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateContactStatus(requestParameters: UpdateContactStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContactInfoDto> {
        const response = await this.updateContactStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOrganizationRaw(requestParameters: UpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOrganization().'
            );
        }

        if (requestParameters['iOrganizationInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationInfoDto',
                'Required parameter "iOrganizationInfoDto" was null or undefined when calling updateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationInfoDtoToJSON(requestParameters['iOrganizationInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateOrganization(requestParameters: UpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationInfoDto> {
        const response = await this.updateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOrganizationAddressRaw(requestParameters: UpdateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPreferredDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOrganizationAddress().'
            );
        }

        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError(
                'addressId',
                'Required parameter "addressId" was null or undefined when calling updateOrganizationAddress().'
            );
        }

        if (requestParameters['iPreferredDto'] == null) {
            throw new runtime.RequiredError(
                'iPreferredDto',
                'Required parameter "iPreferredDto" was null or undefined when calling updateOrganizationAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/addresses/{address-id}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"address-id"}}`, encodeURIComponent(String(requestParameters['addressId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IPreferredDtoToJSON(requestParameters['iPreferredDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPreferredDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateOrganizationAddress(requestParameters: UpdateOrganizationAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPreferredDto> {
        const response = await this.updateOrganizationAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOrganizationNotificationPropertiesRaw(requestParameters: UpdateOrganizationNotificationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOrganizationNotificationProperties().'
            );
        }

        if (requestParameters['iNotificationPropertiesInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iNotificationPropertiesInfoDto',
                'Required parameter "iNotificationPropertiesInfoDto" was null or undefined when calling updateOrganizationNotificationProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/notification-properties`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: INotificationPropertiesInfoDtoToJSON(requestParameters['iNotificationPropertiesInfoDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOrganizationNotificationProperties(requestParameters: UpdateOrganizationNotificationPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrganizationNotificationPropertiesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateOrganizationPropertyRaw(requestParameters: UpdateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertyInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOrganizationProperty().'
            );
        }

        if (requestParameters['iOrganizationPropertyInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationPropertyInfoDto',
                'Required parameter "iOrganizationPropertyInfoDto" was null or undefined when calling updateOrganizationProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/properties`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationPropertyInfoDtoToJSON(requestParameters['iOrganizationPropertyInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertyInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateOrganizationProperty(requestParameters: UpdateOrganizationPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertyInfoDto> {
        const response = await this.updateOrganizationPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOrganizationStatusRaw(requestParameters: UpdateOrganizationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOrganizationStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling updateOrganizationStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isExpressSetupActivation'] != null) {
            queryParameters['is_express_setup_activation'] = requestParameters['isExpressSetupActivation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/statuses/{status}`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"status"}}`, encodeURIComponent(String(requestParameters['status'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOrganizationStatus(requestParameters: UpdateOrganizationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrganizationStatusRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateOverridablePropertyRaw(requestParameters: UpdateOverridablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOverridablePropertiesInfoDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOverridableProperty().'
            );
        }

        if (requestParameters['iOverridablePropertiesInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOverridablePropertiesInfoDto',
                'Required parameter "iOverridablePropertiesInfoDto" was null or undefined when calling updateOverridableProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/overridable-properties`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IOverridablePropertiesInfoDtoToJSON(requestParameters['iOverridablePropertiesInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOverridablePropertiesInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateOverridableProperty(requestParameters: UpdateOverridablePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOverridablePropertiesInfoDto> {
        const response = await this.updateOverridablePropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async validateOrganizationToCreateEmployeeRaw(requestParameters: ValidateOrganizationToCreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling validateOrganizationToCreateEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/employee-validation`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateOrganizationToCreateEmployee(requestParameters: ValidateOrganizationToCreateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.validateOrganizationToCreateEmployeeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async validateOverridablePropertiesRaw(requestParameters: ValidateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOverridablePropertiesValidateDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling validateOverridableProperties().'
            );
        }

        if (requestParameters['iOverridablePropertiesInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iOverridablePropertiesInfoDto',
                'Required parameter "iOverridablePropertiesInfoDto" was null or undefined when calling validateOverridableProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/overridable-properties/validate`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOverridablePropertiesInfoDtoToJSON(requestParameters['iOverridablePropertiesInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOverridablePropertiesValidateDtoFromJSON(jsonValue));
    }

    /**
     */
    async validateOverridableProperties(requestParameters: ValidateOverridablePropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOverridablePropertiesValidateDto> {
        const response = await this.validateOverridablePropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async validateUserNameNotExistsRaw(requestParameters: ValidateUserNameNotExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['names'] == null) {
            throw new runtime.RequiredError(
                'names',
                'Required parameter "names" was null or undefined when calling validateUserNameNotExists().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['names'] != null) {
            queryParameters['names'] = requestParameters['names'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contacts/usernames/exists`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async validateUserNameNotExists(requestParameters: ValidateUserNameNotExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.validateUserNameNotExistsRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetContactsUpHierarchyJobFunctionEnum {
    ACCOUNT_MANAGER = 'ACCOUNT_MANAGER'
}
/**
  * @export
  * @enum {string}
  */
export enum SaveOrganizationLogoLogoTypeEnum {
    LARGE = 'LARGE',
    MINIMIZED = 'MINIMIZED',
    FAVICON = 'FAVICON',
    DARK_LARGE = 'DARK_LARGE',
    DARK_MINIMIZED = 'DARK_MINIMIZED'
}
/**
  * @export
  * @enum {string}
  */
export enum UpdateOrganizationStatusStatusEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
